/**
 * Updates the column list with the user's preferred order and visibility.
 */

import Collection from "../../collections/columns-customizer";

const columnSelector = (columns = [], customColumns = []) => {
  // console.log({ columns, customColumns });

  // create column collection
  const collection = new Collection(columns);

  // handle custom columns
  if (!_.isEmpty(customColumns)) {
    const sortedList = collection.map((column) => {
      // hide columns not in the custom list
      const found = _.indexOf(customColumns, column.getElementId());
      column.set({
        visible: found > -1 ? true : false,
        sequence: found,
        name: column.getName(),
      });

      return column;
    });

    // update state
    collection.reset(sortedList);
  }

  // console.log(collection.toJSON());
  return collection.toJSON();
};

export { columnSelector as default };
